// ---------------------------------------------------------
// Datei: percent.ts
// Zweck: Zentrales Clamping von Prozentwerten (0-100)
// Kontext: Phasen-Fortschritt (completionPercent) kam aus mehreren
//          Quellen (Store-Berechnung, HubSpot project_status) teils
//          ungedeckelt bei UI/API an, was Werte >100% erzeugte.
// Stand: 16. Juli 2026
// ---------------------------------------------------------

export function clampPercent(value: number | null | undefined): number {
  const numeric = Number(value || 0);
  return Number.isFinite(numeric) ? Math.max(0, Math.min(100, numeric)) : 0;
}
